<template>
    <div>

        <rkm-alert>
            <rkm-row>
                <rkm-col cols="auto">
                    <span>
                        <strong>Paciente:</strong>

                        <template v-if="model.faa.paciente.preferenciaNomeId !== enums.preferenciaNome.NOME_SOCIAL">
                            {{ model.faa.paciente.nome }}
                        </template>
                        <template v-else>
                            {{ model.faa.paciente.nome }} <strong>({{ model.faa.paciente.nomeSocial }})</strong>
                        </template>
                    </span>
                </rkm-col>

                <rkm-col cols="auto">
                    <span>
                        <strong>Data de nascimento:</strong> {{ model.faa.dataNascimento }}
                    </span>
                </rkm-col>

                <rkm-col cols="auto">
                    <span>
                        <strong>Sexo:</strong> {{ model.faa.sexoNome }}
                    </span>
                </rkm-col>

                <rkm-col class="text-right">
                    <span>
                        <strong>FAA:</strong> {{ model.faa.numero }}
                    </span>
                </rkm-col>
            </rkm-row>
        </rkm-alert>

        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols=4>
                    <rkm-form-select
                        :disabled="disableProfissionalResponsavel()"
                        :options="getUsuarios"
                        :validations="validations.usuarioResponsavelId"
                        @change="handleUsuarioResponsavel"
                        label="Profissional"
                        show-default-option
                        text-field="nome"
                        v-model="model.faa.usuarioProcedimentoPadrao.lotacaoId"
                        value-field="lotacaoId"
                    />
                </rkm-col>

                <rkm-col cols=6>
                    <rkm-form-input-autocomplete
                        :disabled="disableProcedimentoPadrao"
                        :repository="repositories.procedimento"
                        :requestQueryStringParams="autocompletesRequestParams.queryString.procedimentoPadrao"
                        :searchFields="fields.procedimento"
                        :text-field="p => p && p.codigo && formatProcedimento(p.codigo)"
                        :title="titleProcedimentoPadrao"
                        :validations="validations.procedimentoPadrao"
                        label="Procedimento padrão"
                        placeholder="Código, nome ou apelido"
                        v-rkm-tooltip.hover
                        v-model="model.faa.procedimentoPadrao"
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ formatProcedimento(item.codigo) }} - {{ item.nome }}
                        </template>

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="additionals.searchByApelido">
                                    <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                    <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols=2>
                    <rkm-form-input-autocomplete
                        :repository="repositories.cid"
                        :requestQueryStringParams="autocompletesRequestParams.queryString.cidPadrao"
                        :searchFields="fields.cid"
                        :text-field="c => c && c.codigo && formatCid(c.codigo)"
                        :title="titleCidPadrao"
                        :validations="validations.cidPadrao"
                        label="CID Principal"
                        placeholder="Código ou nome"
                        v-rkm-tooltip.hover
                        v-model="model.faa.cid"
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ formatCid(item.codigo) }} - {{ item.nome }}
                        </template>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-form ref="RkmFormClassificacao">
            <box-classificacao-risco
                :data=" {
                    form: data.form,
                    model: model.faa,
                }"
            />
        </rkm-form>

        <rkm-area title="ADICIONAR PROCEDIMENTOS">
            <rkm-form ref="RkmFormProcedimento">
                <rkm-row>
                    <rkm-col cols=2>
                        <rkm-form-date-picker
                            :max-date="data.form.dataAtual"
                            :min-date="model.faa.data"
                            :validations="validations.dataRealizacaoProcedimento"
                            label="Data"
                            v-model="data.model.dataRealizacaoProcedimento"
                        />
                    </rkm-col>

                    <rkm-col cols=4>
                        <rkm-form-select
                            :disabled="disabledServicos"
                            :options="form.servicos"
                            :validations="validations.servicoId"
                            @change="handleServico"
                            label="Serviço"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.servico.id"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols=4>
                        <rkm-form-input
                            v-if="Number.isInteger(model.itemId)"
                            label="Profissional"
                            v-model="model.procedimentoSaved.usuario.nome"
                            disabled
                        />

                        <rkm-form-select
                            v-else
                            :disabled="disabledUsuarios"
                            :options="form.usuarios"
                            :validations="validations.lotacaoId"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="data.model.usuario.lotacaoId"
                            value-field="lotacaoId"
                        />
                    </rkm-col>

                    <rkm-col class="col-min">
                        <rkm-form-input
                            :title="Number.isInteger(model.itemId) ? model.procedimentoSaved.ocupacao.nome : titleCbo"
                            disabled
                            label="CBO"
                            v-rkm-tooltip.hover
                            :value="Number.isInteger(model.itemId) ? model.procedimentoSaved.ocupacao.codigo : cbo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols=6>
                        <rkm-form-input-autocomplete
                            :disabled="disabledProcedimento"
                            :repository="repositories.procedimento"
                            :requestQueryStringParams="autocompletesRequestParams.queryString.procedimento"
                            :searchFields="fields.procedimento"
                            :text-field="p => formatProcedimento(p.codigo)"
                            :title="titleProcedimento"
                            :validations="validations.procedimento"
                            label="Procedimento"
                            placeholder="Digite o código, nome ou apelido"
                            v-rkm-tooltip.hover
                            v-model="data.model.procedimento"
                        >
                            <template v-slot:itemLabel="{ item }">
                                    {{ formatProcedimento(item.codigo) }} - {{ item.nome }}
                            </template>

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="additionals.searchByApelido">
                                        <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                        <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols=3>
                        <rkm-form-input-autocomplete
                            :disabled="!data.model.procedimento"
                            :repository="repositories.cid"
                            :requestQueryStringParams="autocompletesRequestParams.queryString.cid"
                            :searchFields="fields.cid"
                            :text-field="c => c.codigo && formatCid(c.codigo)"
                            :title="titleCid"
                            :validations="validations.cid"
                            label="CID"
                            placeholder="Digite o código ou o nome"
                            v-rkm-tooltip.hover
                            v-model="data.model.cid"
                        >
                            <template v-slot:itemLabel="{ item }">
                                    {{ formatCid(item.codigo) }} - {{ item.nome }}
                            </template>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="data.model.quantidade"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click.stop="handleProcedimento"
                        >
                            <template v-if="model.itemId">
                                Salvar
                            </template>

                            <template v-else>
                                Incluir
                            </template>
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <lista-procedimentos
                :key="procedimentosKey"
                :edit="handleEdit"
                :items="model.faa.procedimentos"
                @atualizaKey="procedimentosKey++"
            />

        </rkm-area>

        <box-fator-risco
            :disabled="!model.faa.previousDesfechoExtraviada && this.isFaaReaberta()"
            class="mt-4"
            :data=" {
                form: data.form,
                model: model.faa,
            }"
        />

        <rkm-form
            v-show="model.faa.usuarioProcedimentoPadrao.lotacaoId"
            ref="RkmFormDesfecho"
        >
            <box-desfecho
                :data="data"
                :is-medico="isUsuarioSelecionadoMedico()"
                :is-saved="disableDesfecho"
            />
        </rkm-form>
    </div>
</template>

<script>
// Components.
import BoxDesfecho from './components/desfecho/Index'
import BoxFatorRisco from '@/components/pronto-atendimento/components/fator-risco/Index'
import BoxClassificacaoRisco from '@/components/pronto-atendimento/components/classificacao-risco/Index'
import ListaProcedimentos from './components/procedimento/List'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, formats, data, error, object, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: {
        BoxDesfecho,
        BoxFatorRisco,
        BoxClassificacaoRisco,
        ListaProcedimentos,
    },
    computed: {
        competencia() {

            if (this.data.model.dataRealizacaoProcedimento) {

                return moment(this.data.model.dataRealizacaoProcedimento).format('YYYYMM')
            }

            return ''
        },
        getUsuarios() {

            const usuarios = []

            this.data.form.usuarios.forEach(usuario => {
                if (!usuarios.find(u => u.id === usuario.id && u.lotacaoId === usuario.lotacaoId)) {

                    usuarios.push({
                        id: usuario.id,
                        nome: usuario.nome,
                        lotacaoId: usuario.lotacaoId,
                    })
                }
            })

            const usuarioProcedimentoPadrao = this.model.faa.usuarioProcedimentoPadrao

            if (usuarioProcedimentoPadrao.lotacaoId != null
                && !usuarios.find(u => u.lotacaoId === usuarioProcedimentoPadrao.lotacaoId)) {

                usuarios.push({
                    id: usuarioProcedimentoPadrao.id,
                    nome: usuarioProcedimentoPadrao.nome,
                    lotacaoId: usuarioProcedimentoPadrao.lotacaoId,
                })
            }

            return usuarios
        },
        fields() {

            return {
                table: [
                    {
                        key: 'data',
                        label: 'Data',
                        sortable: true,
                    },
                    {
                        key: 'usuario.nome',
                        label: 'Profissional',
                        sortable: true,
                    },
                    {
                        key: 'ocupacao.codigo',
                        label: 'CBO',
                        sortable: true,
                    },
                    {
                        key: 'procedimento.codigo',
                        label: 'Procedimento',
                        sortable: true,
                    },
                    {
                        key: 'cid.codigo',
                        label: 'CID',
                        sortable: true,
                    },
                    {
                        key: 'quantidade',
                        label: 'Quantidade',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        label: 'Ações',
                        class: 'col-min'
                    },
                ],
                procedimento: [
                    this.additionals.searchByApelido
                        ? { key: 'parametrizacao_procedimento.apelido', searchable: true }
                        : { key: 'nome', searchable: true }, { key: 'codigo', searchable: true }
                ],
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        validations() {

            let quantidade = { required: true, min_value: 1}

            if (this.data.model.procedimento && this.data.model.procedimento.quantidadeMaximaExecucao != null) {

                quantidade.max_value = this.data.model.procedimento.quantidadeMaximaExecucao
            }

            const cidMedico = this.getUsuarioByLotacao(this.model.faa.usuarioProcedimentoPadrao.lotacaoId)

            return {
                quantidade,
                dataRealizacaoProcedimento: { required: true },
                procedimentoPadrao: { required: true },
                procedimento: { required: true },
                servicoId: { required: true },
                lotacaoId: { required: true },
                usuarioResponsavelId: { required: true },
                cidPadrao: {
                    required: (cidMedico ? cidMedico.isMedico : true) && this.data.model.desfechoId !== this.enums.desfecho.EVASAO && !this.isFaaReaberta(),
                },
                cid: {
                    required: !!(this.data.model.procedimento && this.data.model.procedimento.hasCidPrincipal)
                },
            }
        },
        cbo() {

            const usuario = this.getUsuarioByLotacao(this.data.model.usuario.lotacaoId, true)

            if (!usuario) return null

            return `${usuario.ocupacao.codigo}`
        },
        disableProcedimentoPadrao() {

            const procIsLoaded = this.model.faa.procedimentoPadrao
                && this.model.faa.procedimentoPadrao.id != null
                && this.model.faa.procedimentoPadrao.isLoaded

            return (this.isFaaReaberta() && procIsLoaded)
                || procIsLoaded
        },
        disableCidPrincipal() {

            const cidIsLoaded = this.model.faa.cid
                && this.model.faa.cid.id != null
                && this.model.faa.cid.isLoaded

            return !this.model.faa.procedimentoPadrao
                || (
                    (this.isFaaReaberta() && cidIsLoaded)
                    || cidIsLoaded
                    || this.disableProcedimentoPadrao
                )
        },
        disabledUsuarios() {

            return this.data.model.servico
                && !this.data.model.servico.id
        },
        disabledServicos() {

            return Number.isInteger(this.model.itemId) || !this.data.model.dataRealizacaoProcedimento
        },
        disabledProcedimento() {

            if (Number.isInteger(this.model.itemId)) {

                return false
            }

            return !this.data.model.usuario.lotacaoId
        },
        disableDesfecho() {

            if (this.verificaDesabilitado.hasDesfechoMedicoLastAtendimento) {

                return true
            }

            const hasSomeDesfecho = (
                this.verificaDesabilitado.desfecho
                && [
                    this.enums.desfecho.ALTA_MEDICA,
                    this.enums.desfecho.OBITO,
                    this.enums.desfecho.ENCAMINHAMENTO_HOSPITALAR,
                ].some(value => value === this.verificaDesabilitado.desfecho.id)
                && this.verificaDesabilitado.usuarioDesfecho && this.data.form.usuariosDesfecho.some(ud => {
                    return ud.id === this.verificaDesabilitado.usuarioDesfecho.id
                })
            ) || this.verificaDesabilitado.desfecho && this.verificaDesabilitado.desfecho.id > 0

            return !this.verificaDesabilitado.previousDesfechoExtraviada && this.isFaaReaberta() && hasSomeDesfecho
        },
        autocompletesRequestParams() {

            const usuario = this.getUsuarioByLotacao(this.data.model.usuario.lotacaoId, true)
            const usuarioResponsavel = this.getUsuarioByLotacao(this.model.faa.usuario.lotacaoId)

            return {
                queryString: {
                    procedimentoPadrao: {
                        cbo: usuarioResponsavel ? usuarioResponsavel.ocupacao.codigo : null,
                        paciente_id: this.model.faa.paciente.id,
                        search_by_apelido: this.additionals.searchByApelido,
                    },
                    cidPadrao: {
                        procedimento_id: this.model.faa.procedimentoPadrao && this.model.faa.procedimentoPadrao.hasCidPrincipal
                            ? this.model.faa.procedimentoPadrao.id
                            : null
                    },
                    procedimento: {
                        cbo: Number.isInteger(this.model.itemId)
                            ? this.model.procedimentoSaved.ocupacao.codigo
                            : (usuario ? usuario.ocupacao.codigo : null),
                        paciente_id: this.model.faa.paciente.id,
                        search_by_apelido: this.additionals.searchByApelido,
                        competencia: this.competencia,
                    },
                    cid: {
                        procedimento_id: this.data.model.procedimento && this.data.model.procedimento.hasCidPrincipal
                            ? this.data.model.procedimento.id
                            : null
                    },
                },
            }
        },
        titleCid() {

            return this.data.model.cid ? this.data.model.cid.nome : ''
        },
        titleProcedimentoPadrao() {

            return this.model.faa.procedimentoPadrao ? this.model.faa.procedimentoPadrao.nome : ''
        },
        titleCidPadrao() {

            return this.model.faa.cid ? this.model.faa.cid.nome : ''
        },
        titleProcedimento() {

            return this.data.model.procedimento ? this.data.model.procedimento.nome : ''
        },
        titleCbo() {

            const usuario = this.getUsuarioByLotacao(this.data.model.usuario.lotacaoId, true)

            if (!usuario) return ''

            return usuario.ocupacao.nome
        }
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            fechamentoFaa: this.getConectaSusRepository('prontoAtendimento.fechamentoFaa')
        }

        this.model.faa = this.data.model.faas.find(f => f.id === this.faaId)

        if(!this.model.faa.procedimentos) {
            this.carregaProcedimentosFaa(this.faaId, this.model.faa.procedimentoPadrao.codigo);
        }

        this.verificaDesabilitado =  this.clone(this.model.faa)

        this.data.model.dataRealizacaoProcedimento = moment(this.model.faa.data, 'DD/MM/YYYY').toDate()
        this.data.form.paciente = this.model.faa.paciente

        this.data.model.desfechoId = this.model.faa.desfecho && this.model.faa.desfecho.id

        if (this.data.model.desfechoId != null
            && this.model.faa.usuarioDesfecho
            && this.model.faa.usuarioDesfecho.id === null) {

            this.model.faa.usuarioDesfecho = this.clone(this.model.faa.usuario)
            this.model.faa.usuarioDesfecho.isLoaded = false
        }

        if (this.data.model.desfechoId === this.enums.desfecho.PACIENTE_LIBERADO) {

            this.data.model.pacienteLiberado.lotacaoId = this.hasUsuarioOnUsuariosNaoMedicosDesfecho(
                this.model.faa.usuarioDesfecho
            )

        } else if (this.data.model.desfechoId === this.enums.desfecho.ALTA_MEDICA) {

            this.data.model.altaMedica.lotacaoId = this.hasUsuarioOnUsuariosDesfecho(this.model.faa.usuarioDesfecho)

        } else if (this.data.model.desfechoId === this.enums.desfecho.ENCAMINHAMENTO_HOSPITALAR) {

            if (this.model.faa.encaminhamentoHospitalar) {

                this.data.model.encaminhamentoHospitalar = this.model.faa.encaminhamentoHospitalar
            }

        } else if (this.data.model.desfechoId === this.enums.desfecho.OBITO) {

            if (this.model.faa.obito) {

                this.data.model.obito = this.model.faa.obito
            }

        } else if (this.data.model.desfechoId === this.enums.desfecho.EVASAO) {

            if (this.model.faa.obito) {

                this.data.model.evasao = this.model.faa.evasao
            }
        }

        if (this.model.faa.usuarioProcedimentoPadrao.lotacaoId === null) {

            this.model.faa.usuarioProcedimentoPadrao = this.clone(this.model.faa.usuario)
            this.model.faa.usuarioProcedimentoPadrao.isLoaded = false
        }

        if (this.model.faa.procedimentoPadrao === null) {

            this.handleUsuarioResponsavel()
        }

        this.addProcedimentoPadraoWatch()

        this.setLoading()

        this.getServicos()
            .then(({ data }) => {

                this.form.servicos = data.form.servicos
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
    },
    data: () => ({
        procedimentosKey: 0,
        enums: { desfecho, preferenciaNome },
        model: {
            itemId: null,
            altaMedica: false,
            faa: null,
            procedimentoSaved: {
                usuario: {
                    nome: '',
                },
                ocupacao: {
                    codigo: '',
                    nome: '',
                },
                previousCodigo: null,
            }
        },
        form: {
            servicos: [],
            usuarios: [],
        },
        additionals: {
            searchByApelido: false,
        },
        verificaDesabilitado: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        resetModel() {

            this.data.model.evasao = this.model.faa.evasao
            this.data.model.encaminhamentoHospitalar = this.model.faa.encaminhamentoHospitalar
            this.data.model.obito = this.model.faa.obito
            this.data.model.quantidade = 1
        },
        isFaaReaberta() {

            return this.model.faa.reabertoEm != null
        },
        disableProfissionalResponsavel() {

             return !this.isFaaReaberta() && this.model.faa.usuarioProcedimentoPadrao.isLoaded
        },
        hasUsuarioOnUsuariosNaoMedicosDesfecho(usuarioDesfecho) {

            if (!usuarioDesfecho) return null

            return (this.data.form.usuariosNaoMedicosDesfecho.some(ud => {
                return ud.lotacaoId === usuarioDesfecho.lotacaoId
            }) && usuarioDesfecho.lotacaoId) || null
        },
        hasUsuarioOnUsuariosDesfecho(usuarioDesfecho) {

            if (!usuarioDesfecho) return null

            return (this.data.form.usuariosDesfecho.some(ud => {
                return ud.lotacaoId === usuarioDesfecho.lotacaoId
            }) && usuarioDesfecho.lotacaoId) || null
        },
        handleProcedimento() {

            this.$refs.RkmFormProcedimento.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.model.faa.procedimentoPadrao
                        && this.model.faa.procedimentoPadrao.codigo === this.data.model.procedimento.codigo
                    ) {

                        this.showConfirmation(
                            `O procedimento que está tentando incluir já está incluso como procedimento padrão. Deseja continuar
                            e adicioná-lo novamente?`,
                            async () => this.addProcedimento(),
                            async () => this.resetFormProcedimento()
                        )

                        return
                    }

                    this.addProcedimento()
                })
        },
        addProcedimento() {

            const usuario = this.getUsuarioByLotacao(this.data.model.usuario.lotacaoId, true)

            const item = {
                id: this.model.itemId,
                data: moment(this.data.model.dataRealizacaoProcedimento).format('DD/MM/YYYY'),
            }

            item.procedimento = this.clone(this.data.model.procedimento)

            item.cid = {
                id: this.data.model.cid ? this.data.model.cid.id : null,
                nome: this.data.model.cid ? this.data.model.cid.nome : null,
                codigo: this.data.model.cid ? this.data.model.cid.codigo : null,
            }

            if (!Number.isInteger(this.model.itemId)) {

                item.servico = {
                    id: this.data.model.servico.id
                }

                item.usuario = {
                    id: usuario.id,
                    nome: usuario.nome,
                    lotacaoId: usuario.lotacaoId
                }

                item.ocupacao = {
                    codigo: usuario.ocupacao.codigo,
                    nome: usuario.ocupacao.nome,
                }
            }

            item.quantidade = this.data.model.quantidade;

            const quantidadeMaxima = this.data.model.procedimento.quantidadeMaximaExecucao;


            const procedimentoExistente = !this.model.faa.procedimentos ? false : this.model.faa.procedimentos.find(p => p.procedimento.codigo === item.procedimento.codigo);

            if (procedimentoExistente) {

                const totalQuantidadeMesmoProcedimento = this.model.faa.procedimentos
                    .filter(p => p.procedimento.codigo === item.procedimento.codigo)
                    .reduce((total, procedimento) => total + parseInt(procedimento.quantidade), 0);

                const soma = totalQuantidadeMesmoProcedimento + parseInt(item.quantidade);

                if (item.id) {
                    const index = this.model.faa.procedimentos.findIndex((i) => i.id === item.id);

                    if (index > -1) {
                        const procedimento = this.model.faa.procedimentos[index];

                        const novaSoma = totalQuantidadeMesmoProcedimento - parseInt(procedimento.quantidade) + parseInt(item.quantidade);

                        if (novaSoma <= quantidadeMaxima) {
                            Object.assign(procedimento, item);
                        } else {
                            this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: `A quantidade máxima de procedimentos foi atingida.`
                            });
                            return;
                        }
                    }
                } else if (soma <= quantidadeMaxima) {

                    item.id = this.uniqueId('pronto-atendimento-fechamento-faa-' + new Date().getTime());
                    this.model.faa.procedimentos.push(item);
                    this.procedimentosKey++;

                } else {
                    this.createNotification({
                        type: 'alert',
                        color: 'danger',
                        title: 'Ação não permitida',
                        message: `A quantidade máxima de procedimentos foi atingida.`
                    });
                    return;
                }

            } else {

                const totalQuantidadeMesmoProcedimento = this.model.faa.procedimentos
                    .filter(p => p.procedimento.codigo === item.procedimento.codigo)
                    .reduce((total, procedimento) => total + parseInt(procedimento.quantidade), 0);

                const soma = totalQuantidadeMesmoProcedimento + parseInt(item.quantidade);

                if (item.id) {
                    const index = this.model.faa.procedimentos.findIndex((i) => i.id === item.id);

                    if (index > -1) {
                        const procedimento = this.model.faa.procedimentos[index];

                        const novaSoma = totalQuantidadeMesmoProcedimento - parseInt(procedimento.quantidade) + parseInt(item.quantidade);

                        if (novaSoma <= quantidadeMaxima) {
                            Object.assign(procedimento, item);
                        } else {
                            this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: `A quantidade máxima de procedimentos foi atingida.`
                            });
                            return;
                        }
                    }
                } else if (soma <= quantidadeMaxima) {
                    item.id = this.uniqueId('pronto-atendimento-fechamento-faa-' + new Date().getTime());
                    this.model.faa.procedimentos.push(item);
                    this.procedimentosKey++;
                } else {
                    this.createNotification({
                        type: 'alert',
                        color: 'danger',
                        title: 'Ação não permitida',
                        message: `A quantidade máxima de procedimentos foi atingida.`
                    });
                    return;
                }
            }

            this.resetFormProcedimento();
            this.$nextTick(() => this.$refs.RkmFormProcedimento.resetValidator());
        },
        resetFormProcedimento() {

            this.data.model.procedimento = null
            this.data.model.cid = null
            this.data.model.quantidade = 1

            if (this.model.itemId !== null) {

                this.data.model.servico.id = null
                this.data.model.servico.nome = null
                this.data.model.usuario.id = null
                this.data.model.usuario.nome = null
                this.data.model.usuario.lotacaoId = null

                this.model.procedimentoSaved.usuario.nome = ''
                this.model.procedimentoSaved.ocupacao.codigo = ''
                this.model.procedimentoSaved.ocupacao.nome = ''
                this.model.procedimentoSaved.previousCodigo = null
            }

            this.model.itemId = null
        },
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.data.model.classificacaoRiscoId = this.data.model.faas.find(f => f.id === this.faaId)

                    this.$refs.RkmFormDesfecho.validate()
                        .then(valid => {

                            if (!valid) return

                            if (!this.hasProcedimento()) {

                                return this.createNotification({
                                    type: 'alert',
                                    color: 'danger',
                                    title: 'Ação não permitida',
                                    message: `É necessário informar pelo menos um procedimento.`
                                })
                            }

                            if (this.data.model.desfechoId === null) {
                                return this.createNotification({
                                    type: 'alert',
                                    color: 'danger',
                                    title: 'Ação não permitida',
                                    message: 'Desfecho do atendimento é obrigatório.'
                                })
                            }

                            const usuario = this.getUsuarioByLotacao(this.model.faa.usuarioProcedimentoPadrao.lotacaoId)

                            const request = {
                                usuario_responsavel_id: usuario.id,
                                procedimentos: this.getProcedimentosAdicionados(),
                                fatores_risco: this.model.faa.fatoresRisco,
                                desfecho_id: this.data.model.desfechoId,
                                hora: this.model.faa.hora,
                                classificacao_risco_id: this.model.faa.classificacaoRiscoId
                            }

                            if (this.data.model.desfechoId === this.enums.desfecho.PACIENTE_LIBERADO) {

                                request.pacienteLiberado = {
                                    lotacao_id: this.data.model.pacienteLiberado.lotacaoId
                                }

                            }
                            else if (this.data.model.desfechoId === this.enums.desfecho.ALTA_MEDICA) {

                                request.altaMedica = {
                                    lotacao_id: this.data.model.altaMedica.lotacaoId
                                }

                            } else if (this.data.model.desfechoId === this.enums.desfecho.EVASAO) {

                                request.evasao = this.data.model.evasao

                            } else if (this.data.model.desfechoId === this.enums.desfecho.ENCAMINHAMENTO_HOSPITALAR) {

                                request.encaminhamento_hospitalar = {
                                    ...this.data.model.encaminhamentoHospitalar,
                                    cid_id: this.data.model.encaminhamentoHospitalar.cid && this.data.model.encaminhamentoHospitalar.cid.id,
                                }

                            } else if (this.data.model.desfechoId === this.enums.desfecho.OBITO) {

                                request.obito = {
                                    obitoEm: moment(
                                        moment(
                                            this.data.model.obito.dataObito).format('YYYY-MM-DD') + ' ' +
                                            this.data.model.obito.horaObito
                                        ).format('DD/MM/YYYY HH:mm'),
                                    declaracao: this.data.model.obito.declaracao,
                                    causa: this.data.model.obito.causa,
                                    cidId: this.data.model.obito.cid.id,
                                    lotacao_id: this.data.model.obito.lotacaoId,
                                }
                            }

                            this.setLoading()

                            this.repositories.fechamentoFaa.update(

                                    this.model.faa.id,
                                    this.camelObjectKeysToSnakeRecursive(request)
                                )
                                .then(() => {

                                    this.showSaveNotification()

                                    const index = this.data.model.faas.findIndex(f => f.id === this.model.faa.id)
                                    this.data.model.faas.splice(index, 1)
                                    this.$emit('saved', true)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        })
                })

            return true
        },
        hasProcedimento() {

            return this.model.faa.procedimentos.length > 0
                || this.model.faa.procedimentoPadrao
        },
        getProcedimentosAdicionados() {

            const procedimentos = this.model.faa.procedimentos
                .map(item => {

                    return {
                        id: Number.isInteger(item.id) ? item.id : null,
                        data: item.data,
                        procedimento_id: item.procedimento.id,
                        cid_id: item.cid.id,
                        quantidade: parseInt(item.quantidade),
                        ocupacao_id: item.ocupacao_id,
                        lotacao_id: item.usuario.lotacaoId,
                        is_parametrizado: false,
                    };
            })

            if (this.model.faa.procedimentoPadrao
                && !this.model.faa.procedimentoPadrao.isLoaded
                && this.model.faa.procedimentoPadrao.id) {

                const usuario = this.getUsuarioByLotacao(this.model.faa.usuarioProcedimentoPadrao.lotacaoId)

                procedimentos.push({
                    id: null,
                    data: this.model.faa.data,
                    procedimento_id: this.model.faa.procedimentoPadrao.id,
                    cid_id: this.model.faa.cid ? this.model.faa.cid.id : null,
                    quantidade: 1,
                    usuario_id: usuario.id,
                    lotacao_id: this.model.faa.usuarioProcedimentoPadrao.lotacaoId,
                    is_parametrizado: true,
                })
            }

            return procedimentos
        },
        handleServico() {

            this.data.model.usuario.id = null
            this.data.model.usuario.nome = null
            this.data.model.usuario.lotacaoId = null
            this.data.model.procedimento = null
            this.data.model.cid = null

            if (this.data.form.periodo.start && this.data.form.periodo.end) {

                this.setLoading()

                this.getUsuariosByServico()
                    .then(({ data }) => {

                        this.form.usuarios = data.form.usuarios
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        async handleEdit(item) {

            if (!item) return

            try {

                this.model.itemId = item.id

                if (Number.isInteger(item.id)) {

                    this.data.model.servico.id = null
                    this.form.usuarios = []

                    this.model.procedimentoSaved.usuario.nome = item.usuario.nome
                    this.model.procedimentoSaved.ocupacao.codigo = item.ocupacao.codigo
                    this.model.procedimentoSaved.ocupacao.nome = item.ocupacao.nome
                    this.model.procedimentoSaved.previousCodigo = item.procedimento.codigo
                }
                else {

                    this.setLoading()

                    this.data.model.servico.id = item.servico.id

                    const { data } = await this.getUsuariosByServico()

                    this.form.usuarios = data.form.usuarios
                    this.data.model.usuario.lotacaoId = item.usuario.lotacaoId
                }

                this.data.model.procedimento = this.clone(item.procedimento)
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                await this.$nextTick()

                this.data.model.cid = {
                    id: item.cid.id,
                    nome: item.cid.nome,
                    codigo: item.cid.codigo,
                }

                this.data.model.quantidade = parseInt(item.quantidade)

                if (!Number.isInteger(item.id)) {

                    this.unsetLoading()
                }
            }
        },
        async getUsuariosByServico() {

            const filters = {
                start: this.model.faa.data
            }

            if (this.data.model.servico.id) {

                filters.servico_id = this.data.model.servico.id
            }

            return this.repositories.fechamentoFaa.list(filters)
        },
        handleUsuarioResponsavel() {

            this.model.faa.procedimentoPadrao = null
            this.model.faa.cid = null

            const usuario = this.getUsuarioByLotacao(this.model.faa.usuarioProcedimentoPadrao.lotacaoId)
            this.model.faa.usuario.id = usuario && usuario.id
            this.model.faa.usuario.lotacaoId = usuario && usuario.lotacaoId
            this.model.faa.usuario.nome = usuario && usuario.nome

            if (this.isUsuarioSelecionadoMedico() && this.hasProcedimentoPadrao()) {

                this.model.faa.procedimentoPadrao = this.clone(this.data.form.procedimentoPadrao)
            }
        },
        isUsuarioSelecionadoMedico() {

            const usuario = this.getUsuarioByLotacao(this.model.faa.usuarioProcedimentoPadrao.lotacaoId)

            return usuario ? usuario.isMedico : false
        },
        getUsuarioByLotacao(id, fromAddProcedimento = false) {

            if (!this.data.form) return null

            if (fromAddProcedimento) {

                return this.form.usuarios.find(u => u.lotacaoId === id) || null
            }

            return this.data.form.usuarios.find(u => u.lotacaoId === id) || null
        },
        hasProcedimentoPadrao() {

            return this.data.form && this.data.form.procedimentoPadrao.codigo !== null
        },
        async getServicos() {

            const filters = {
                start: this.model.faa.data
            }

            return this.repositories.fechamentoFaa.list(filters)
        },
        addProcedimentoPadraoWatch() {

            this.$watch('model.faa.procedimentoPadrao', {
                deep: true,
                handler(newValue, oldValue) {

                    if (newValue !== oldValue) {

                        const procDuplicado = !!this.model.faa.procedimentos.find(p =>
                            p.procedimento.codigo === (newValue && newValue.codigo)
                        )

                        if (procDuplicado) {

                            this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: `Procedimento já está na lista.`
                            })

                            this.model.faa.procedimentoPadrao = null

                            return
                        }

                        this.model.faa.cid = null
                    }
                }
            })
        },

        carregaProcedimentosFaa(faaId, procedimentoPadraoFaaCodigo) {
            this.repositories.fechamentoFaa.procedimento({
                faa_id: faaId,
                procedimento_padrao_faa_codigo: procedimentoPadraoFaaCodigo
            })
            .then(({data}) => {
                this.model.faa.procedimentos = data;
            })
            .catch(this.handleError)
        }
    },
    mixins: [ repository, formats, data, error, object, stringCase ],
    props: {
        data: { type: Object, required: true },
        faaId: { type: Number }
    },
    watch: {
        'data.model.procedimento': function (newValue, oldValue) {

            if (newValue !== oldValue) {

                if (newValue) {

                    const isCompetenciaValid = !!this.data.form.sigtapCompetencias.find(f => f.id === newValue.competenciaId)

                    if (!isCompetenciaValid) {

                        const fn = async () => this.data.model.procedimento = null

                        this.showConfirmation(
                            'Este procedimento foi revogado ou não faz parte das competências de faturamento permitidas. O procedimento não será faturado. Deseja continuar?',
                            async () => {},
                            fn,
                        )
                    }
                }

                this.data.model.cid = null
            }
        },
        'data.model.dataRealizacaoProcedimento': function () {

            this.data.model.servico.id = null
            this.data.model.usuario.id = null
            this.data.model.usuario.lotacaoId = null
            this.data.model.procedimento = null
            this.data.model.cid = null
        },
        'data.model.desfechoId': function (newValue) {

            if (newValue) {

                this.model.faa.desfecho.id = newValue
                this.model.faa.desfecho.nome = this.data.form.desfechos.find(d => d.id === newValue).nome
            }
        },
    }
}
</script>